module.exports = "<ng-content select=\"[conteudoJanela]\"></ng-content>"


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/janela/janela.component.html
// module id = ../../../../../src/app/angular-base-ui/janela/janela.component.html
// module chunks = 1